// we want the yaml generated to be in the order we describe
/* eslint-disable sort-keys-fix/sort-keys-fix */

import { platformListTablesTeam } from '@cloudquery/api-platform';
import { fetchAllPages } from 'shared/base';

import { ReportYamlItem } from '../../types/report';

const tablesToSelect = [
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_ec2_instances'
        LIMIT 1
      ),
      ec2 as (
        SELECT
          arrayJoin(arrayFilter(x -> x != '',
            arrayMap(y -> JSONExtractString(y, 'Association', 'PublicIp'),
                JSONExtractArrayRaw(coalesce(network_interfaces, '[]'))
            )
          )) AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud as cloud,
          _cq_region as region,
          _cq_name as name,
          'aws_ec2_instances' as resource_type_id,
          tags
        FROM aws_ec2_instances ec2
        WHERE ip_address IS NOT NULL
        UNION ALL
        SELECT
          arrayJoin(arrayFilter(x -> x != '',
            arrayFlatten(
              arrayMap(y -> arrayMap(
                  z -> JSONExtractString(z, 'Ipv6Address'),
                  JSONExtractArrayRaw(coalesce(y, '[]'), 'Ipv6Addresses')
                ),
                JSONExtractArrayRaw(coalesce(network_interfaces, '[]'))
              )
            )
          )) AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud as cloud,
          _cq_region as region,
          _cq_name as name,
          'aws_ec2_instances' as resource_type_id,
          tags
        FROM aws_ec2_instances ec2
        WHERE ip_address IS NOT NULL
      )
      SELECT ec2.*, rtl.resource_type_label as resource_type
      FROM ec2
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = ec2.resource_type_id`,
    tables: ['aws_ec2_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_dms_replication_instances'
        LIMIT 1
      ),
      dms as (
        SELECT
          replication_instance_public_ip_address AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_dms_replication_instances' as resource_type_id,
          tags
        FROM aws_dms_replication_instances
        WHERE ip_address != ''
      )
      SELECT dms.*, rtl.resource_type_label as resource_type
      FROM dms
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = dms.resource_type_id
    `,
    tables: ['aws_dms_replication_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_lightsail_instances'
        LIMIT 1
      ),
      li as (
        SELECT
          coalesce(lsi.ip_address, li.public_ip_address) AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_lightsail_instances' as resource_type_id,
          tags
        FROM aws_lightsail_instances li
        LEFT JOIN aws_lightsail_static_ips lsi ON li.name = lsi.attached_to
        WHERE li.public_ip_address IS NOT NULL  OR lsi.ip_address IS NOT NULL
      )
      SELECT li.*, rtl.resource_type_label as resource_type
      FROM li
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = li.resource_type_id
    `,
    tables: ['aws_lightsail_instances', 'aws_lightsail_static_ips'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_lightsail_static_ips'
        LIMIT 1
      ),
      lsi as (
        SELECT
          ip_address AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_lightsail_static_ips' as resource_type_id,
          tags
        FROM aws_lightsail_static_ips
        WHERE is_attached = 0
      )
      SELECT lsi.*, rtl.resource_type_label as resource_type
      FROM lsi
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = lsi.resource_type_id
    `,
    tables: ['aws_lightsail_static_ips'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_ec2_customer_gateways'
        LIMIT 1
      ),
      cg as (
        SELECT
          ip_address AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_ec2_customer_gateways' as resource_type_id,
          tags
        FROM aws_ec2_customer_gateways
        WHERE state = 'available'
      )
      SELECT cg.*, rtl.resource_type_label as resource_type
      FROM cg
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = cg.resource_type_id
    `,
    tables: ['aws_ec2_customer_gateways'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_ssm_instances'
        LIMIT 1
      ),
      ssm as (
        SELECT
          ip_address AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_ssm_instances' as resource_type_id,
          tags
        FROM aws_ssm_instances
        WHERE association_status != 'Success'
      )
      SELECT ssm.*, rtl.resource_type_label as resource_type
      FROM ssm
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = ssm.resource_type_id
    `,
    tables: ['aws_ssm_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_workspaces_workspaces'
        LIMIT 1
      ),
      ws as (
        SELECT
          ip_address AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_workspaces_workspaces' as resource_type_id,
          tags
        FROM aws_workspaces_workspaces
      )
      SELECT ws.*, rtl.resource_type_label as resource_type
      FROM ws
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = ws.resource_type_id
    `,
    tables: ['aws_workspaces_workspaces'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_ec2_network_interfaces'
        LIMIT 1
      ),
      nic as (
        SELECT
          JSONExtractString(association, 'PublicIp') AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_ec2_network_interfaces' as resource_type_id,
          tags
        FROM aws_ec2_network_interfaces
        WHERE JSONExtractString(attachment, 'InstanceId') = '' and ip_address != ''
      )
      SELECT nic.*, rtl.resource_type_label as resource_type
      FROM nic
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = nic.resource_type_id
    `,
    tables: ['aws_ec2_network_interfaces'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_emr_cluster_instances'
        LIMIT 1
      ),
      emr as (
        SELECT
          public_ip_address AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'aws_emr_cluster_instances' as resource_type_id,
          tags
        FROM aws_emr_cluster_instances
        WHERE ip_address IS NOT NULL
      )
      SELECT emr.*, rtl.resource_type_label as resource_type
      FROM emr
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = emr.resource_type_id
    `,
    tables: ['aws_emr_cluster_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'aws_ec2_eips'
        LIMIT 1
      ),
      eip as (
        SELECT
          public_ip AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_id::String AS name,
          'aws_ec2_eips' as resource_type_id,
          tags
        FROM aws_ec2_eips
        WHERE ip_address IS NOT NULL AND network_interface_id IS NULL
      )
      SELECT eip.*, rtl.resource_type_label as resource_type
      FROM eip
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = eip.resource_type_id
    `,
    tables: ['aws_ec2_eips'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_compute_vpn_gateways'
        LIMIT 1
      ),
      vpn as (
        SELECT
          ip_address as ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'gcp_compute_vpn_gateways' as resource_type_id,
          tags
        FROM gcp_compute_vpn_gateways
        ARRAY JOIN JSONExtractArrayRaw(coalesce(vpn_interfaces, '{}')) AS vpn_interface
        ARRAY JOIN array(JSONExtractString(coalesce(vpn_interface, '{}'), 'ipAddress'), JSONExtractString(coalesce(vpn_interface, '{}'), 'ipv6Address')) as ip_address
      )
      SELECT vpn.*, rtl.resource_type_label as resource_type
      FROM vpn
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = vpn.resource_type_id
    `,
    tables: ['gcp_compute_vpn_gateways'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_compute_external_vpn_gateways'
        LIMIT 1
      ),
      vpn as (
        SELECT
          ip_address as ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'gcp_compute_external_vpn_gateways' as resource_type_id,
          tags
        FROM gcp_compute_external_vpn_gateways
        ARRAY JOIN JSONExtractArrayRaw(coalesce(interfaces, '{}')) AS vpn_interface
        ARRAY JOIN array(JSONExtractString(coalesce(vpn_interface, '{}'), 'ipAddress'), JSONExtractString(coalesce(vpn_interface, '{}'), 'ipv6Address')) as ip_address
      )
      SELECT vpn.*, rtl.resource_type_label as resource_type
      FROM vpn
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = vpn.resource_type_id
    `,
    tables: ['gcp_compute_external_vpn_gateways'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_filestore_instances'
        LIMIT 1
      ),
      filestore as (
        SELECT
          arrayJoin(JSONExtract(JSONExtractRaw(coalesce(networks, '[]')), 'ipAddresses', 'Array(String)')) AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'gcp_filestore_instances' as resource_type_id,
          tags
        FROM gcp_filestore_instances
      )
      SELECT filestore.*, rtl.resource_type_label as resource_type
      FROM filestore
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = filestore.resource_type_id
    `,
    tables: ['gcp_filestore_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_baremetalsolution_instances'
        LIMIT 1
      ),
      bm as (
        SELECT
          JSONExtractString(coalesce(network, '{}'), 'ipAddress') AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'gcp_baremetalsolution_instances' as resource_type_id,
          tags
        FROM gcp_baremetalsolution_instances
        ARRAY JOIN JSONExtractArrayRaw(coalesce(networks, '[]')) as network
      )
      SELECT bm.*, rtl.resource_type_label as resource_type
      FROM bm
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = bm.resource_type_id
    `,
    tables: ['gcp_baremetalsolution_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_sql_instances'
        LIMIT 1
      ),
      sql as (
        SELECT
          public_ip AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_platform_id AS name,
          'gcp_sql_instances' as resource_type_id,
          tags
        FROM (
          SELECT
            *,
            JSONExtractString(arrayJoin(JSONExtractArrayRaw(coalesce(ip_addresses, '[]'))), 'ipAddress') AS public_ip,
            JSONExtractString(arrayJoin(JSONExtractArrayRaw(coalesce(ip_addresses, '[]'))), 'type') AS type
          FROM gcp_sql_instances
        )
        WHERE type = 'PRIMARY'
      )
      SELECT sql.*, rtl.resource_type_label as resource_type
      FROM sql
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = sql.resource_type_id
    `,
    tables: ['gcp_sql_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_compute_instances'
        LIMIT 1
      ),
      compute as (
        SELECT
          JSONExtractString(access, 'nat_i_p') as ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'gcp_compute_instances' as resource_type_id,
          tags
        FROM gcp_compute_instances
        ARRAY JOIN JSONExtractArrayRaw(coalesce(network_interfaces, '[]')) AS nic
        ARRAY JOIN JSONExtractArrayRaw(nic, 'access_configs') as access
        WHERE ip_address != ''
      )
      SELECT compute.*, rtl.resource_type_label as resource_type
      FROM compute
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = compute.resource_type_id
    `,
    tables: ['gcp_compute_instances'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_batch_jobs'
        LIMIT 1
      ),
      batch as (
        SELECT
          JSONExtractString(interface, 'network')  as ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'gcp_batch_jobs' as resource_type_id,
          tags
        FROM gcp_batch_jobs
        ARRAY JOIN JSONExtractArrayRaw(JSONExtractRaw(coalesce(allocation_policy, '{}'), 'network'), 'networkInterfaces') as interface
        WHERE JSONExtractBool(interface, 'noExternalIpAddress') = 0
      )
      SELECT batch.*, rtl.resource_type_label as resource_type
      FROM batch
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = batch.resource_type_id
    `,
    tables: ['gcp_batch_jobs'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'gcp_compute_addresses'
        LIMIT 1
      ),
      compute as (
        SELECT
          address as ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'gcp_compute_addresses' as resource_type_id,
          tags
        FROM gcp_compute_addresses
        WHERE status = 'IN_USE'
        AND address_type = 'EXTERNAL'
      )
      SELECT compute.*, rtl.resource_type_label as resource_type
      FROM compute
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = compute.resource_type_id
    `,
    tables: ['gcp_compute_addresses'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_compute_virtual_machines'
        LIMIT 1
      ),
      compute as (
        SELECT
          JSONExtractString(pip.properties, 'ipAddress')  as ip_address,
          COALESCE(nullif(vm._cq_account_name, ''), vm._cq_account) AS account,
          vm._cq_cloud AS cloud,
          vm._cq_region AS region,
          vm._cq_name AS name,
          'azure_compute_virtual_machines' as resource_type_id,
          vm.tags
        FROM azure_compute_virtual_machines vm
        ARRAY JOIN JSONExtractArrayRaw(JSONExtractRaw(coalesce(properties, '{}'), 'networkProfile'), 'networkInterfaces') AS networkInterface
        INNER JOIN azure_network_interfaces nic ON nic.id = JSONExtractString(networkInterface, 'id')
        ARRAY JOIN JSONExtractArrayRaw(coalesce(nic.properties, '[]'), 'ipConfigurations') AS ipc
        INNER JOIN azure_network_public_ip_addresses pip ON pip.id = JSONExtractString(JSONExtractRaw(JSONExtractRaw(ipc, 'properties'), 'publicIPAddress'), 'id')
        WHERE ip_address != ''
      )
      SELECT compute.*, rtl.resource_type_label as resource_type
      FROM compute
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = compute.resource_type_id
    `,
    tables: ['azure_compute_virtual_machines'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'kubernetes_core_services'
        LIMIT 1
      ),
      k8s as (
        SELECT
          JSONExtractString(ingress, 'ip') AS ip_address,
          COALESCE(nullif(_cq_account_name, ''), _cq_account) AS account,
          _cq_cloud AS cloud,
          _cq_region AS region,
          _cq_name AS name,
          'kubernetes_core_services' as resource_type_id,
          map() AS tags
        FROM k8s_core_services
        ARRAY JOIN JSONExtractArrayRaw(coalesce(status_load_balancer, '{}'), 'ingress') AS ingress
        WHERE JSONLength(coalesce(status_load_balancer, '{}'), 'ingress') > 0
      )
      SELECT k8s.*, rtl.resource_type_label as resource_type
      FROM k8s
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = k8s.resource_type_id
    `,
    tables: ['kubernetes_core_services'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_network_load_balancers'
        LIMIT 1
      ),
      nlb as (
        SELECT
          JSONExtractString(pip.properties, 'ipAddress') AS ip_address,
          COALESCE(nullif(nlb._cq_account_name, ''), nlb._cq_account) AS account,
          nlb._cq_cloud AS cloud,
          nlb._cq_region AS region,
          nlb._cq_name AS name,
          'azure_network_load_balancers' as resource_type_id,
          nlb.tags
        FROM azure_network_load_balancers AS nlb
        ARRAY JOIN JSONExtractArrayRaw(coalesce(nlb.properties, '{}'), 'frontendIPConfigurations') AS fipc
        INNER JOIN azure_network_public_ip_addresses pip ON pip.id = JSONExtractString(JSONExtractRaw(JSONExtractRaw(coalesce(fipc, '{}'), 'properties'), 'publicIPAddress'), 'id')
      )
      SELECT nlb.*, rtl.resource_type_label as resource_type
      FROM nlb
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = nlb.resource_type_id
    `,
    tables: ['azure_network_load_balancers'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_network_application_gateways'
        LIMIT 1
      ),
      nag as (
        SELECT
          JSONExtractString(pip.properties, 'ipAddress') AS ip_address,
          COALESCE(nullif(nag._cq_account_name, ''), nag._cq_account) AS account,
          nag._cq_cloud AS cloud,
          nag._cq_region AS region,
          nag._cq_name AS name,
          'azure_network_application_gateways' as resource_type_id,
          tags
        FROM azure_network_application_gateways AS nag
        ARRAY JOIN JSONExtractArrayRaw(coalesce(nag.properties, '{}'), 'frontendIPConfigurations') AS fipc
        INNER JOIN azure_network_public_ip_addresses pip ON pip.id = JSONExtractString(JSONExtractRaw(JSONExtractRaw(coalesce(fipc, '{}'), 'properties'), 'publicIPAddress'), 'id')
      )
      SELECT nag.*, rtl.resource_type_label as resource_type
      FROM nag
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = nag.resource_type_id
    `,
    tables: ['azure_network_application_gateways'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_network_virtual_network_gateways'
        LIMIT 1
      ),
      vng as (
        SELECT
          JSONExtractString(pip.properties, 'ipAddress') AS ip_address,
          COALESCE(nullif(vng._cq_account_name, ''), vng._cq_account) AS account,
          vng._cq_cloud AS cloud,
          vng._cq_region AS region,
          vng._cq_name AS name,
          'azure_network_virtual_network_gateways' as resource_type_id,
          tags
        FROM azure_network_virtual_network_gateways AS vng
        ARRAY JOIN JSONExtractArrayRaw(coalesce(vng.properties, '{}'), 'ipConfigurations') AS ipc
        INNER JOIN azure_network_public_ip_addresses pip ON pip.id = JSONExtractString(JSONExtractRaw(JSONExtractRaw(coalesce(ipc, '{}'), 'properties'), 'publicIPAddress'), 'id')
      )
      SELECT vng.*, rtl.resource_type_label as resource_type
      FROM vng
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = vng.resource_type_id
    `,
    tables: ['azure_network_virtual_network_gateways'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_network_nat_gateways'
        LIMIT 1
      ),
      ng as (
        SELECT
          JSONExtractString(pip.properties, 'ipAddress') AS ip_address,
          COALESCE(nullif(ng._cq_account_name, ''), ng._cq_account) AS account,
          ng._cq_cloud AS cloud,
          ng._cq_region AS region,
          ng._cq_name AS name,
          'azure_network_nat_gateways' as resource_type_id,
          tags
        FROM azure_network_nat_gateways AS ng
        ARRAY JOIN
        JSONExtractArrayRaw(coalesce(ng.properties, '{}'), 'publicIpAddresses') AS pia
        INNER JOIN azure_network_public_ip_addresses pip ON pip.id = JSONExtractString(coalesce(pia, '{}'), 'id')
      )
      SELECT ng.*, rtl.resource_type_label as resource_type
      FROM ng
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = ng.resource_type_id
    `,
    tables: ['azure_network_nat_gateways'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_network_vpn_gateways'
        LIMIT 1
      ),
      vpng as (
        SELECT
          JSONExtractString(pip.properties, 'ipAddress') AS ip_address,
          COALESCE(nullif(vpng._cq_account_name, ''), vpng._cq_account) AS account,
          vpng._cq_cloud AS cloud,
          vpng._cq_region AS region,
          vpng._cq_name AS name,
          'azure_network_vpn_gateways' as resource_type_id,
          vpng.tags
        FROM azure_network_vpn_gateways AS vpng
        ARRAY JOIN JSONExtractArrayRaw(coalesce(vpng.properties, '{}'), 'ipConfigurations') AS ipc
        INNER JOIN azure_network_public_ip_addresses pip ON pip.id = JSONExtractString(JSONExtractRaw(JSONExtractRaw(coalesce(ipc, '{}'), 'properties'), 'publicIPAddress'), 'id')
      )
      SELECT vpng.*, rtl.resource_type_label as resource_type
      FROM vpng
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = vpng.resource_type_id
    `,
    tables: ['azure_network_vpn_gateways'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_storage_accounts'
        LIMIT 1
      ),
      sa as (
        SELECT
          JSONExtractString(ipRule, 'value') AS ip_address,
          COALESCE(nullif(sa._cq_account_name, ''), sa._cq_account) AS account,
          sa._cq_cloud AS cloud,
          sa._cq_region AS region,
          sa._cq_name AS name,
          'azure_storage_accounts' as resource_type_id,
          sa.tags
        FROM azure_storage_accounts AS sa
        ARRAY JOIN JSONExtractArrayRaw(JSONExtractRaw(coalesce(properties, '{}'), 'networkAcls'), 'ipRules') as ipRule
        WHERE JSONExtractString(ipRule, 'action') = 'Allow'
      )
      SELECT sa.*, rtl.resource_type_label as resource_type
      FROM sa
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = sa.resource_type_id
    `,
    tables: ['azure_storage_accounts'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_redis_caches'
        LIMIT 1
      ),
      rc as (
        SELECT
          JSONExtractString(properties, 'staticIP') as ip_address, -- Ideally we'd also check PublicNetworkAccess. Looks like a gap in the integration
          COALESCE(nullif(rc._cq_account_name, ''), rc._cq_account) AS account,
          rc._cq_cloud AS cloud,
          rc._cq_region AS region,
          rc._cq_name AS name,
          'azure_redis_caches' as resource_type_id,
          rc.tags
        FROM azure_redis_caches AS rc
        WHERE ip_address != ''
        -- AND PublicNetworkAccess = 1
      )
      SELECT rc.*, rtl.resource_type_label as resource_type
      FROM rc
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = rc.resource_type_id
    `,
    tables: ['azure_redis_caches'],
  },
  {
    select: `
      WITH resource_type_labels AS (
        SELECT resource_type_label, resource_type FROM cloud_assets
        WHERE resource_type = 'azure_apimanagement_service'
        LIMIT 1
      ),
      ams as (
        SELECT
          JSONExtractString(pip.properties, 'ipAddress') as ip_address,
          COALESCE(nullif(ams._cq_account_name, ''), ams._cq_account) AS account,
          ams._cq_cloud AS cloud,
          ams._cq_region AS region,
          ams._cq_name AS name,
          'azure_apimanagement_service' as resource_type_id,
          ams.tags
        FROM azure_apimanagement_service AS ams
        ARRAY JOIN JSONExtractArrayRaw(coalesce(ams.properties, '{}'), 'PublicIPAddresses') AS pipid
        INNER JOIN azure_network_public_ip_addresses pip ON pip.id = pipid
        WHERE JSONExtractString(coalesce(ams.properties, '{}'), 'PublicNetworkAccess') = 'Enabled'
      )
      SELECT ams.*, rtl.resource_type_label as resource_type
      FROM ams
      INNER JOIN resource_type_labels rtl ON rtl.resource_type = ams.resource_type_id
    `,
    tables: ['azure_apimanagement_service'],
  },
];

const emptyReportQuery = `
      SELECT '' as ip_address, '' as account, '' as cloud, '' as region, '' as name, '' as resource_type, '' as tags limit 0
`;

const getReportQuery = (allTables: string[]) => {
  const filteredTables = tablesToSelect.filter((t) => {
    return t.tables.every((table) => allTables.includes(table));
  });

  if (filteredTables.length === 0) {
    return emptyReportQuery;
  }

  const baseQuery = `
      SELECT *
      FROM (
          ${filteredTables.map((t) => t.select).join(' UNION ALL ')}
      )
      WHERE 1=1 and cloud = '?' and ip_address LIKE '%?%'
      ORDER BY
      IPv4StringToNumOrNull(coalesce(ip_address, '')) ASC,
      IPv6StringToNumOrNull(coalesce(ip_address, '')) ASC
  `;

  return baseQuery;
};

export async function getReportItems(team: string) {
  const data = await fetchAllPages((page) =>
    platformListTablesTeam(team, { page, per_page: 1000 }),
  );
  const allTables = data?.data?.items?.map((item: { name: string }) => item.name) ?? [];
  const baseQuery = getReportQuery(allTables);

  const widgets: ReportYamlItem[] = [
    {
      title: 'Public IP Addresses',
      display: {
        type: 'table',
      },
      query: `
    select ip_address, cloud, account, region, name, resource_type, tags
    from (
      ${baseQuery}
    )
    WHERE NOT (
      isIPAddressInRange(coalesce(nullIf(ip_address, ''), '10.0.0.0'), '10.0.0.0/8') OR
      isIPAddressInRange(coalesce(nullIf(ip_address, ''), '172.16.0.0'), '172.16.0.0/12') OR
      isIPAddressInRange(coalesce(nullIf(ip_address, ''), '192.168.0.0'), '192.168.0.0/16') OR
      isIPAddressInRange(coalesce(nullIf(ip_address, ''), 'fc00::'), 'fc00::/7')  -- ULA (private)
    )
    order by cloud, account, region, name
    `,
    },
  ];

  return { widgets };
}
